export const SHOW_MODAL = "[app] SHOW_MODAL";
export const HIDE_MODAL = "[app] HIDE_MODAL";
